export const EChatTabTarget = {
  SelfMedication: 'self-medication',
  Complaint: 'complaint',
} as const;
export type TChatTabTarget =
  (typeof EChatTabTarget)[keyof typeof EChatTabTarget];

export function parseChatTabTarget(value: string): TChatTabTarget | null {
  return Object.values(EChatTabTarget).includes(value as TChatTabTarget)
    ? (value as TChatTabTarget)
    : null;
}
